import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Space,
  Card,
  Statistic,
  Progress,
  Tag,
  Empty,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  RangePickerItem,
  SegmentedItem,
} from "../../../../Components/Items";
import {
  FileExcelOutlined,
  FilePdfOutlined,
  CloudServerOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import reporteXmlPdf from "../../../../Pdf/reporteXmlPdf";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TIPOS_LABEL = {
  I: "I - Ingreso",
  P: "P - Pago",
  E: "E - Egreso",
  N: "N - Nómina",
  T: "T - Traslado",
};
const TIPOS_ORDEN = ["I", "P", "E", "N", "T"];

class ReporteXml extends Component {
  state = {
    loading: false,
    dataReporte: null,
    filtrosAplicados: null,
  };

  atras() {
    this.props.history.goBack();
  }

  componentDidMount() {
    this.consultarReporteXml({
      periodo: [moment().startOf("month"), moment().endOf("month")],
      filtroTipo: "",
    });
  }

  consultarReporteXml(values) {
    this.setState({ loading: true });
    const [fechaInicio, fechaFin] = values.periodo || [];
    const body = {
      empresaId: this.props.empresaId,
      fechaInicio: fechaInicio ? fechaInicio.toISOString() : null,
      fechaFin: fechaFin ? fechaFin.toISOString() : null,
      filtroTipo: values.filtroTipo || "",
    };
    axios
      .post("reportesAdministrativos/reporteXml", body, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            dataReporte: res.data.data,
            filtrosAplicados: body,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      })
      .catch(() => {
        message.error("Ha sucedido un error y no se cargo bien el reporte");
        this.setState({ loading: false });
      });
  }

  transformarGrafica(grafica = []) {
    const fechasSet = new Set();
    const porTipo = {};
    TIPOS_ORDEN.forEach((t) => (porTipo[t] = {}));

    grafica.forEach((g) => {
      fechasSet.add(g.fecha);
      if (!porTipo[g.tipo]) porTipo[g.tipo] = {};
      porTipo[g.tipo][g.fecha] = g.count;
    });

    const fechas = Array.from(fechasSet).sort();
    return TIPOS_ORDEN
      .filter((t) => Object.keys(porTipo[t]).length > 0)
      .map((tipo) => ({
        id: TIPOS_LABEL[tipo],
        data: fechas.map((f) => ({ x: f, y: porTipo[tipo][f] || 0 })),
      }));
  }

  descargarExcel() {
    const data = this.state.dataReporte;
    if (!data) return;
    const datos = (data.xmls || []).map((x) => ({
      Fecha: x.fecha ? moment(x.fecha).format("DD/MM/YYYY") : "",
      UUID: x.uuid || "",
      Tipo: TIPOS_LABEL[x.tipoDeComprobante] || x.tipoDeComprobante || "",
      Serie: x.serie || "",
      Folio: x.folio || "",
      "RFC Emisor": x.emisorRfc || "",
      "Nombre Emisor": x.emisorNombre || "",
      "RFC Receptor": x.receptorRfc || "",
      "Nombre Receptor": x.receptorNombre || "",
      Subtotal: x.subtotal || 0,
      Total: x.total || 0,
      Moneda: x.moneda || "",
      "Forma de Pago": x.formaDePago || "",
      "Método de Pago": x.metodoDePago || "",
      Estado: x.estado === 0 ? "Cancelada" : "Vigente",
      Contabilizada: x.contabilizada === 2 ? "Sí" : "No",
    }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(datos), "XMLs");

    const totales = data.totales || {};
    const resumen = [
      { Concepto: "Total", Valor: totales.total || 0 },
      { Concepto: "Contabilizadas", Valor: totales.contabilizadas || 0 },
      { Concepto: "No Contabilizadas", Valor: totales.noContabilizadas || 0 },
      { Concepto: "Canceladas", Valor: totales.canceladas || 0 },
      { Concepto: "Pendientes", Valor: totales.pendientes || 0 },
      { Concepto: "Monto Total", Valor: totales.montoTotal || 0 },
      { Concepto: "Monto Contabilizado", Valor: totales.montoContabilizado || 0 },
      { Concepto: "Monto Faltante", Valor: totales.montoFaltante || 0 },
    ];
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(resumen), "Resumen");

    XLSX.writeFile(wb, `Reporte_XML_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    const data = this.state.dataReporte;
    if (!data) return;
    const filtros = this.state.filtrosAplicados || {};
    pdfMake
      .createPdf(
        reporteXmlPdf({
          totales: data.totales,
          xmls: data.xmls,
          fechaInicio: filtros.fechaInicio,
          fechaFin: filtros.fechaFin,
          filtroTipo: filtros.filtroTipo,
        })
      )
      .download(`Reporte_XML_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const data = this.state.dataReporte;
    const totales = data?.totales;
    const seriesGrafica = data ? this.transformarGrafica(data.grafica || []) : [];
    const porcentajeContabilizado =
      totales && totales.total > 0
        ? Math.round((totales.contabilizadas / totales.total) * 100)
        : 0;

    const columnsXml = [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : ""),
        sorter: (a, b) => (a.fecha < b.fecha ? -1 : a.fecha > b.fecha ? 1 : 0),
      },
      {
        title: "Tipo",
        dataIndex: "tipoDeComprobante",
        key: "tipoDeComprobante",
        render: (v) => TIPOS_LABEL[v] || v,
      },
      { title: "Serie", dataIndex: "serie", key: "serie", buscar: "serie" },
      { title: "Folio", dataIndex: "folio", key: "folio", buscar: "folio" },
      {
        title: "Emisor",
        key: "emisor",
        render: (_, r) => (
          <div>
            <div style={{ fontSize: 12, fontWeight: "bold" }}>{r.emisorRfc}</div>
            <div style={{ fontSize: 12, color: "#666" }}>{r.emisorNombre}</div>
          </div>
        ),
        buscar: "emisorNombre",
      },
      {
        title: "Receptor",
        key: "receptor",
        render: (_, r) => (
          <div>
            <div style={{ fontSize: 12, fontWeight: "bold" }}>{r.receptorRfc}</div>
            <div style={{ fontSize: 12, color: "#666" }}>{r.receptorNombre}</div>
          </div>
        ),
        buscar: "receptorNombre",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
        sorter: (a, b) => (a.total || 0) - (b.total || 0),
      },
      {
        title: "Estado",
        key: "estado",
        align: "center",
        render: (_, r) => {
          const tags = [];
          if (r.estado === 0) {
            tags.push(<Tag color="red" key="c">Cancelada</Tag>);
          } else {
            tags.push(<Tag color="green" key="v">Vigente</Tag>);
          }
          if (r.contabilizada === 2) {
            tags.push(<Tag color="green" key="yc">YC</Tag>);
          } else if (r.estado === 1 && r.estadoCancelacion !== 1) {
            tags.push(<Tag color="red" key="nc">NC</Tag>);
          }
          return <Space size={4}>{tags}</Space>;
        },
      },
    ];

    return (
      <Form
        name="reporteXml"
        onFinish={this.consultarReporteXml.bind(this)}
        onFinishFailed={this.onFinishFailed}
        initialValues={{
          periodo: [moment().startOf("month"), moment().endOf("month")],
          filtroTipo: "",
        }}
      >
        <PageHeader
          onBack={this.atras.bind(this)}
          title={(
            <span>
              Reporte XML &nbsp;<CloudServerOutlined />
            </span>
          )}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              {data && (
                <ButtonItem
                  blanco
                  onClick={() => this.descargarExcel()}
                  icon={<FileExcelOutlined />}
                >
                  Excel
                </ButtonItem>
              )}
              {data && (
                <ButtonItem
                  blanco
                  onClick={() => this.descargarPdf()}
                  icon={<FilePdfOutlined />}
                >
                  PDF
                </ButtonItem>
              )}
              <ButtonItem type="primary" htmlType="submit">
                Consultar
              </ButtonItem>
            </Space>
          }
        />

        <Spin spinning={this.state.loading}>
          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingTop: 10,
              borderRadius: 5,
              marginBottom: 10,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Row gutter={[16, 16]} align="middle">
              <Col xs={24} md={10}>
                <FormItem name="periodo" required noStyle>
                  <RangePickerItem />
                </FormItem>
              </Col>
              <Col xs={24} md={14}>
                <FormItem name="filtroTipo" noStyle>
                  <SegmentedItem
                    options={[
                      { label: "Todas", value: "" },
                      { label: "Ingreso", value: "I" },
                      { label: "Pago", value: "P" },
                      { label: "Egreso", value: "E" },
                      { label: "Nómina", value: "N" },
                      { label: "Traslado", value: "T" },
                    ]}
                  />
                </FormItem>
              </Col>
            </Row>
          </div>

          {totales && (
            <>
              <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                    <Statistic
                      title="Total"
                      value={totales.total}
                      prefix={<FileTextOutlined style={{ color: "#00b5e2" }} />}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                    <Statistic
                      title="Contabilizadas"
                      value={totales.contabilizadas}
                      valueStyle={{ color: "#52c41a" }}
                      prefix={<CheckCircleOutlined />}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                    <Statistic
                      title="No Contabilizadas"
                      value={totales.noContabilizadas}
                      valueStyle={{ color: "#ff4d4f" }}
                      prefix={<CloseCircleOutlined />}
                    />
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                    <Statistic
                      title="Canceladas"
                      value={totales.canceladas}
                      valueStyle={{ color: "#faad14" }}
                      prefix={<StopOutlined />}
                    />
                  </Card>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
                <Col xs={24} md={8}>
                  <Card style={{ borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                    <Statistic title="Monto Total" value={totales.montoTotal} precision={2} prefix="$" />
                  </Card>
                </Col>
                <Col xs={24} md={8}>
                  <Card style={{ borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                    <Statistic
                      title="Monto Contabilizado"
                      value={totales.montoContabilizado}
                      precision={2}
                      valueStyle={{ color: "#52c41a" }}
                      prefix="$"
                    />
                  </Card>
                </Col>
                <Col xs={24} md={8}>
                  <Card style={{ borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
                    <Statistic
                      title="Monto Faltante"
                      value={totales.montoFaltante}
                      precision={2}
                      valueStyle={{ color: "#ff4d4f" }}
                      prefix="$"
                    />
                  </Card>
                </Col>
              </Row>

              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  borderRadius: 5,
                  marginBottom: 10,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <h3 style={{ marginBottom: 8 }}>Avance de contabilización</h3>
                <Progress
                  percent={porcentajeContabilizado}
                  status={porcentajeContabilizado === 100 ? "success" : "active"}
                  strokeColor={{ "0%": "#00b5e2", "100%": "#52c41a" }}
                />
                <div style={{ marginTop: 8, color: "#666", fontSize: 13 }}>
                  {totales.contabilizadas} de {totales.total} XMLs contabilizados
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  borderRadius: 5,
                  marginBottom: 10,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <h3 style={{ marginBottom: 8 }}>Comprobantes por tipo</h3>
                <div style={{ height: 360 }}>
                  {seriesGrafica.length > 0 ? (
                    <ResponsiveLine
                      data={seriesGrafica}
                      margin={{ top: 20, right: 140, bottom: 70, left: 60 }}
                      enableSlices="x"
                      useMesh={true}
                      xScale={{ type: "point" }}
                      yScale={{ type: "linear", min: 0, max: "auto", stacked: false }}
                      curve="monotoneX"
                      lineWidth={2}
                      pointSize={5}
                      pointBorderWidth={1}
                      pointColor={{ theme: "background" }}
                      pointBorderColor={{ from: "serieColor" }}
                      colors={["#00b5e2", "#ff6633", "#52c41a", "#722ed1", "#faad14"]}
                      axisTop={null}
                      axisRight={null}
                      axisBottom={{
                        tickSize: 5,
                        tickPadding: 8,
                        tickRotation: 45,
                        tickValues: (seriesGrafica[0]?.data || [])
                          .map((d) => d.x)
                          .filter((_, i, arr) =>
                            arr.length <= 12 ? true : i % Math.ceil(arr.length / 12) === 0
                          ),
                      }}
                      axisLeft={{ tickSize: 5, tickPadding: 8 }}
                      enableGridX={false}
                      legends={[
                        {
                          anchor: "right",
                          direction: "column",
                          translateX: 120,
                          translateY: 0,
                          itemWidth: 110,
                          itemHeight: 18,
                          symbolSize: 10,
                          symbolShape: "circle",
                          itemOpacity: 0.85,
                          effects: [{ on: "hover", style: { itemOpacity: 1 } }],
                        },
                      ]}
                    />
                  ) : (
                    <Empty description="Sin datos para graficar" />
                  )}
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <h3 style={{ marginBottom: 8 }}>Detalle de XMLs</h3>
                <TableItem
                  rowKey={(v) => v._id || v.uuid}
                  columns={columnsXml}
                  dataSource={data.xmls || []}
                  size="small"
                />
              </div>
            </>
          )}
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteXml);
